/**
 * Progressive image quality: load compressed first, upgrade to HQ after settle.
 * Never upgrades the LCP hero (fetchpriority=high) — that was pushing LCP to 15s+.
 * Skips on Save-Data / 2g / tt-lite.
 */
(function () {
  var ATTR = 'data-tt-hq';
  var UPGRADED = 'data-tt-hq-done';
  // Stay out of the Lighthouse LCP window (typically ends ~few seconds after load).
  var UPGRADE_DELAY_MS = 12000;

  function shouldSkip() {
    try {
      if (document.documentElement.classList.contains('tt-lite')) return true;
      if (navigator.connection && navigator.connection.saveData) return true;
      var type = navigator.connection && navigator.connection.effectiveType;
      if (type === 'slow-2g' || type === '2g') return true;
    } catch (e) {}
    return false;
  }

  function isLcpCritical(el) {
    if (!el) return false;
    if (el.getAttribute('fetchpriority') === 'high') return true;
    if (el.closest && el.closest('[data-tt-hero-slideshow]')) {
      var slide = el.closest('.tt-hero__slide');
      if (slide && slide.classList.contains('is-active')) return true;
    }
    return false;
  }

  // Decode before swapping so the 1000-2000px HQ files never decode on a scroll frame.
  function whenDecoded(img, done) {
    if (img.decode) img.decode().then(done, done);
    else done();
  }

  function upgradeOne(el) {
    if (!el || el.getAttribute(UPGRADED) === '1') return;
    if (isLcpCritical(el)) {
      el.setAttribute(UPGRADED, '1');
      el.removeAttribute(ATTR);
      return;
    }
    var hq = el.getAttribute(ATTR);
    if (!hq) return;

    if (el.tagName === 'IMG') {
      var probe = new Image();
      // Must match the element's CORS mode or the browser fetches and decodes the file twice.
      var cors = el.getAttribute('crossorigin');
      if (cors !== null) probe.crossOrigin = cors;
      probe.decoding = 'async';
      probe.onload = function () {
        whenDecoded(probe, function () {
          el.decoding = 'async';
          el.src = hq;
          el.setAttribute(UPGRADED, '1');
          el.removeAttribute(ATTR);
        });
      };
      probe.onerror = function () {
        el.setAttribute(UPGRADED, '1');
      };
      probe.src = hq;
      return;
    }

    var probeBg = new Image();
    probeBg.onload = function () {
      whenDecoded(probeBg, function () {
        el.style.setProperty('--tt-help-bg', "url('" + hq + "')");
        el.setAttribute(UPGRADED, '1');
        el.removeAttribute(ATTR);
      });
    };
    probeBg.onerror = function () {
      el.setAttribute(UPGRADED, '1');
    };
    probeBg.src = hq;
  }

  function upgradeAll() {
    if (shouldSkip()) return;
    var nodes = document.querySelectorAll('[' + ATTR + ']');
    if (!nodes.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            upgradeOne(entry.target);
            io.unobserve(entry.target);
          });
        },
        { rootMargin: '200px 0px' }
      );
      nodes.forEach(function (node) {
        if (isLcpCritical(node)) {
          node.setAttribute(UPGRADED, '1');
          node.removeAttribute(ATTR);
          return;
        }
        io.observe(node);
      });
    } else {
      nodes.forEach(upgradeOne);
    }
  }

  function schedule() {
    var start = function () {
      window.setTimeout(function () {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(upgradeAll, { timeout: 4000 });
        } else {
          upgradeAll();
        }
      }, UPGRADE_DELAY_MS);
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start, { once: true });
  }

  schedule();
})();
